import { render, staticRenderFns } from "./DialogBotOnePlatformConsentDetail.vue?vue&type=template&id=137ac8d3&"
import script from "./DialogBotOnePlatformConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DialogBotOnePlatformConsentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports